import { customGet } from "../../api/customApi";
import entityType from "../../api/entityType";
import Actions from "./dashboardConstants";

export const getUnbatchedDocSummary =
  (brokerId, submissionDate) => async (dispatch) => {
    dispatch({ type: Actions.GET_UNBATCHED_DOCS_SUMMARY });

    const payload = await customGet(
      entityType.BATCH,
      "GetUnbatchedDocsSummary",
      {
        params: {
          brokerId: brokerId,
          submissionDate: submissionDate,
        },
      }
    );
    dispatch({ type: Actions.GET_UNBATCHED_DOCS_SUMMARY_SUCCEEDED, payload });
  };

export const getInventoryAlertSummary =
  (brokerId) => async (dispatch) => {
    dispatch({ type: Actions.GET_INVENTORY_ALERT_SUMMARY });

    const payload = await customGet(
      entityType.INVENTORY,
      "GetInventoryAlerts",
      {
        params: { brokerId }
      }
    );

    dispatch({
      type: Actions.GET_INVENTORY_ALERT_SUMMARY_SUCCEEDED,
      payload,
    });
  };